import { render } from "./ViewJob.vue?vue&type=template&id=71bded8b&ts=true"
import script from "./ViewJob.vue?vue&type=script&lang=ts"
export * from "./ViewJob.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__